import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Row} from "react-bootstrap";

class ProcessOverviewItem extends React.Component {
    render() {
        return (

            <Row className={"process-overview-item-row"}>
                <div className={"process-overview-item-icons col"}>
                    <FontAwesomeIcon icon={this.props.itemIcon}/>
                </div>
                <div className={"process-overview-plan col-7"}>
                    {this.props.itemLabel}
                </div>
            </Row>

        );
    }

}

export default ProcessOverviewItem;